import type { Archive } from "../../domain/types";
import { callLLMWithRoutes } from "../llm";
import {
  resolveFeatureRoutes,
  type FeatureRoutingSettings,
} from "../featureRoutes";
import { buildCoreRuntimeContext } from "../coreRuntimeContext";
import {
  assemblePresetMessages,
  type MainPromptPreset,
} from "../presetAssembler";
import { loadApprovedMainPreset } from "../../features/presets/catalog";
import { buildPendingQuickChatContext } from "../../features/quick-chat/service";
export async function runMainChat(
  archive: Archive,
  input: string,
  context: { rag: string; memory: string; guidance: string },
  settings: FeatureRoutingSettings & { mainPreset?: MainPromptPreset },
  onToken: (s: string) => void,
  signal?: AbortSignal,
  debug?: { archiveName: string; turnId: string },
) {
  const approved = settings.mainPresetProfileId
    ? await loadApprovedMainPreset(settings.mainPresetProfileId)
    : null;
  const history = archive.messages.map(
    (m) =>
      ({
        role: m.role === "system" ? "system" : m.role,
        content: m.content,
      }) as const,
  );
  const result = await callLLMWithRoutes(
    resolveFeatureRoutes("core-chat", settings),
    assemblePresetMessages({
      preset: approved?.preset ?? settings.mainPreset,
      runtimeVars: buildCoreRuntimeContext(archive).runtimeVars,
      rag: context.rag,
      memory: [context.memory, buildPendingQuickChatContext(archive)]
        .filter(Boolean)
        .join("\n\n"),
      guidance: context.guidance,
      history,
      input,
      assistantPrefill: approved?.assistantPrefill,
    }),
    {
      signal,
      stream: true,
      onToken,
      debug: {
        featureId: "core-chat",
        archiveName: debug?.archiveName,
        turnId: debug?.turnId,
      },
    },
  );
  return result.text;
}
